import { NgModule } from '@angular/core';
import {
  CybMainComponent
} from './layout.component';

@NgModule({
  declarations: [
    CybMainComponent
  ],
  exports: [
    CybMainComponent
  ]
})

export class CybLayoutModule { }
